import { Layer } from "./layer";
export class GraphicLayer extends Layer {
    constructor() {
        super();
        this._graphics = {}; //Map<string, Graphic>
    }
    set crs(value) {
        this._crs = value;
        let graphic = this._first;
        while (graphic) {
            graphic.geometry.crs = value;
            graphic = graphic.next;
        }
    }
    addGraphic(graphic, last = true) {
        this._graphics[graphic.id] = graphic;
        graphic.geometry.crs = this._crs;
        if (this._origin)
            graphic.transform(this._origin, this._zoom);
        if (!this._first) {
            this._first = graphic;
            this._last = graphic;
        }
        else {
            if (!last) {
                this._first.prev = graphic;
                graphic.next = this._first;
                this._first = graphic;
            }
            else {
                this._last.next = graphic;
                graphic.prev = this._last;
                this._last = graphic;
            }
        }
    }
    removeGraphic(graphic) {
        if (this._first == graphic) {
            this._first = graphic.next;
        }
        if (this._last == graphic) {
            this._last = graphic.prev;
        }
        if (graphic.prev) {
            graphic.prev.next = graphic.next;
        }
        if (graphic.next) {
            graphic.next.prev = graphic.prev;
        }
        graphic.prev = null;
        graphic.next = null;
        delete this._graphics[graphic.id];
    }
    clearGraphics() {
        this._first = null;
        this._last = null;
        this._graphics = {};
    }
    /**
     * 数据变换
     * @param {ScreenXY} origin - 窗口坐标原点
     * @param {number} zoom - 当前缩放级别
     */
    transform(origin, zoom) {
        this._origin = origin;
        this._zoom = zoom;
        let graphic = this._first;
        while (graphic) {
            graphic.transform(origin, zoom);
            graphic = graphic.next;
        }
    }
    draw(ctx, zoom, redrawBounds) {
        if (!this.visible || this.minZoom > zoom || this.maxZoom < zoom)
            return;
        let graphic = this._first;
        // let count = 0;
        while (graphic) {
            if (graphic.visible) {
                if (!redrawBounds || (graphic.geometry && graphic.geometry.screenBounds && graphic.geometry.screenBounds.intersects(redrawBounds))) {
                    graphic.draw(ctx);
                    // count += 1;
                }
            }
            graphic = graphic.next;
        }
        // console.log("count:", count);
    }
    query(screenXY, zoom, bounds) {
        if (!this.visible || this.minZoom > zoom || this.maxZoom < zoom)
            return [];
        let graphic = this._first;
        const graphics = [];
        while (graphic) {
            if (graphic.geometry && graphic.geometry.screenBounds && graphic.geometry.screenBounds.intersects(bounds)) {
                if (graphic.geometry.contains(screenXY)) {
                    graphics.push(graphic);
                }
            }
            graphic = graphic.next;
        }
        return graphics;
    }
    on(types, fn, context) {
        let graphic = this._first;
        while (graphic) {
            graphic.on(types, fn, context);
            graphic = graphic.next;
        }
        return this;
    }
}
